<template>
  <div class="text-block block-card card-border">
    <v-expansion-panel :value="panel" expand>
      <v-expansion-panel-content :lazy="lazyRendering">
        <template v-slot:header>
          <div class="block-card-title handle">
            <div class="title-icon">
              <v-icon class="white--text text-lg-2">map</v-icon>
            </div>

            <h4>
              Google Map
              <v-icon
                v-if="errorsCount && errorsCount.errorsCount"
                color="error"
                style="margin-left: 4px"
                >error</v-icon
              >
              <span class="text--error" v-if="!validData"
                >(Invalid Card Data)</span
              >
            </h4>
          </div>
        </template>
        <div class="block-card-body" v-if="validData">
          <label for="">Insert image link</label>
          <v-text-field
            placeholder="Image Url"
            outline
            v-model="data.imageUrl"
            @change="handleImageUpload"
          />
          <label for=""><span class="text-bold">Or</span> Upload image</label>
          <image-input
            :url="data.imageUrl"
            types="image/jpg, image/jpeg, image/png"
            :maxFiles="1"
            :maxFilesize="5"
            class="mb-3"
            @onUploadComplete="handleImageUpload"
            @onFileRemove="handleImageRemove"
          />
          <form-validation v-model="errorsCount">
            <v-layout>
              <v-flex xs-6 class="pl-0">
                <label>Latitude</label>
                <vTextareaAutocomplete
                  v-model="data.lat"
                  :type="'textfield'"
                  :validation-rules="[(v) => !!v || 'Latitude is required']"
                />
              </v-flex>
              <v-flex xs-6 class="pr-0">
                <label>longitude</label>
                <vTextareaAutocomplete
                  v-model="data.lon"
                  :type="'textfield'"
                  :validation-rules="[(v) => !!v || 'longitude is required']"
                />
              </v-flex>
            </v-layout>

            <label>Button title</label>
            <vTextareaAutocomplete
              v-model="data.buttonTitle"
              :type="'textfield'"
              :counter="20"
              :validation-rules="[
                (v) => !!v || 'Button label is required',
                (v) =>
                  (v && v.length < 80) ||
                  'Button should be less than 20 character',
              ]"
            />

            <label>Title</label>
            <vTextareaAutocomplete
              v-model="data.title"
              :type="'textfield'"
              :validation-rules="[
                (v) => !!v || 'Title is required',
                (v) =>
                  (v && v.length < 80) ||
                  'Title should be less than 80 character',
              ]"
              :counter="80"
            />

            <label>Description</label>
            <vTextareaAutocomplete
              v-model="data.description"
              :type="'textfield'"
              :validation-rules="[
                (v) => !!v || 'Description is required',
                (v) =>
                  (v && v.length < 80) ||
                  'Description should be less than 80 character',
              ]"
              :counter="80"
            />
          </form-validation>
        </div>
        <slot name="tail" />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
import common from "../../../../utils/common";
import FormValidation from "../FormValidation";
import imageInput from "./common-inner-blocks/image-uploader-dropzone";
export default {
  name: "CardMap",
  components: {
    imageInput,
    FormValidation,
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
    index: {
      type: Number,
      default: () => {
        return 0;
      },
    },
    blocksList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    validData: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  data() {
    return {
      errorsCount: { errorsCount: 0 },
      lazyRendering: true,
      valid: true,
      panel: 1,
      common,
      autocompleteImageUrlValidationrRules: [(v) => !!v || "Field is required"],
    };
  },
  computed: {},
  watch: {
    errorsCount(val) {
      this.$emit("input", { errorsCount: val.errorsCount });
      this.data.errorsCount = val.errorsCount;
    },
  },
  mounted() {
    if (this.data.errorsCount !== undefined) {
      this.errorsCount = this.data.errorsCount;
    } else {
      // disabling Lazy rendering so we can grip errors count
      this.lazyRendering = false;
      setTimeout(() => {
        // then we turn it on again to keep the performance up
        this.lazyRendering = true;
      }, 1000);
    }
  },
  methods: {
    handleImageUpload(e) {
      this.data.imageUrl = e[0].url;
    },
    handleImageRemove() {
      this.data.imageUrl = "";
    },
  },
};
</script>

<style scoped></style>
